<template>
<div>
  <div class="container-base format-detail"
       v-if="format">
    <div class="flex align-items-center">
      <h1>{{ format.title }}</h1>
    </div>
    <div class="card detail">

      <div class="card-thumbnail">
        <ul class="doc-sample-images">
          <li v-for="(img, index) in format.images"
              :key="index"><img :src="img"
                 :alt='`${format.title}テンプレート ${index}`'></li>
        </ul>
      </div>
      <div class="card-data">
        <div class="description">{{ format.description }}</div>
        <router-link :to="{ name: 'formatEdit', params: {formatId: format.id}}"
                     v-ripple>
          <el-button class="button-block"
                     type="primary"
                      style="background-color:#E95B10;border-color:#E95B10;"
                     v-ripple>入力をはじめる</el-button>
        </router-link>
        <div class="text-center">
          <el-button @click="$eventHub.$emit('open-account-dialog')"
                     type="text">
            <span v-if="$yagi.profile.autoSaveEnabled"
                      style="color:#E95B10;"
                  class="autosave-status on"><i class="el-icon-circle-check"></i> ブラウザに自動保存: オン</span>
            <span v-else
                      style="color:#E95B10;"
                  class="autosave-status off"><i class="el-icon-circle-close"></i> ブラウザに自動保存: オフ</span>
          </el-button>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    formatId: {
      type: String
    }
  },
  computed: {
    format: function (id) {
      return this.$site.getFormatById(this.formatId)
    }
  },
  beforeMount: function () {
    if (!this.format) {
      this.$router.replace({
        name: 'notFound'
      })
    }
  }
}
</script>
